import React, { useState } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { useDispatch } from "react-redux";
import "./popup.scss";
import PoppupBusiness from "../PoppupBusiness";
import PoppupQuestionaire from "../PoppupQuestionaire/index";
import PoppupProfile from "../PoppupProfile";
import { needCorrectionAction } from "../../actions/pgmAction";
import { NotificationManager } from "react-notifications";
import Loader from "../loaderComponent/Loader";
import { useTranslation } from "react-i18next";

const Poppup = ({
  modaldetail,
  setmodaldetails,
  setmodaldetailsBusiness,
  modaldetailsbusiness,
  personalRef,
  setPersonalRef,
  commercialRef,
  setCommercialRef,
  modaldetailsquestion,
  setmodaldetailsQuestion,
  handleClose,
  handleDelete,
  userid,
}) => {
  const [profile, setProfile] = useState("profile");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();

  const handelCLick = (param) => {
    setProfile(param);
  };

  const [inputValues, setInputValues] = useState({
    profile: {},
    business: {},
  });

  const handleChanges = (fieldName, value) => {
    const updatedValues = { ...inputValues[profile] };
    updatedValues[fieldName] = value;
    setInputValues({ ...inputValues, [profile]: updatedValues });
  };

  const [profileState, setProfileState] = useState([]);
  const [businessState, setBusinessState] = useState([]);

  const handleChange = (fieldName, label, value, section) => {
    const updatedData = {
      name: label,
      remark: value,
      slug: fieldName.toLowerCase().replace(/ /g, "_").replace("/", "_"),
    };

    let updatedState, setUpdatedState;

    if (section === "profile") {
      updatedState = profileState;
      setUpdatedState = setProfileState;
    } else if (section === "business") {
      updatedState = businessState;
      setUpdatedState = setBusinessState;
    } 

    const index = updatedState.findIndex((item) => item.slug === updatedData.slug);

    if (index !== -1) {
      const updatedSection = [...updatedState];
      updatedSection[index] = updatedData;
      setUpdatedState(updatedSection);
    } else {
      setUpdatedState((prevState) => [...prevState, updatedData]);
    }
  };

  const onclcikSubmit = async () => {
    const apiReq = {
      user_id: userid,
      profile_correction: {
        field_remark: profileState,
      },
      business_profile_correction: {
        field_remark: businessState,
      },
    };
    setIsLoading(true);
    let response = await dispatch(needCorrectionAction(apiReq, userid));
    if (response == 200 || response != null) {
      NotificationManager.success(response.data.message);
      setIsLoading(false);
      handleClose();
      window.scroll(0, 0);
    }
    else if (response === undefined) {
      setIsLoading(false);
    }
  };

  return (
    <div className="popup_containers">
      <div className="popupcontainers">
        <div className="poupfirst_para">
          <span>{t('nedcorrectionpopup.correctionmade')}</span>
          <img src={Image_Url.CROSSICONS} onClick={handleClose} />
        </div>
        <div className="poupsecond_para">
          {t('nedcorrectionpopup.popuptext')}
        </div>
        <div className="poupthird_para">
          <span className={`profiledetailspgm ${profile === "profile" ? "dark_color" : ""}`} onClick={() => handelCLick("profile")} >
            {t('pgmlist.profiledetails')}
          </span>
          <span className={`profiledetailspgm ${profile === "business" ? "dark_color" : ""}`} onClick={() => handelCLick("business")} >
            {t('pgmlist.businesscontact')}
          </span>
        </div>
        <div className="scroll-div">
          {profile === "profile" && (
            <PoppupProfile
              profiledata={modaldetail}
              setmodaldetails={setmodaldetails}
              handleChange={handleChange}
              state={profileState}
              profiledatas={inputValues.profile}
              handleChanges={handleChanges}
              handleDelete={handleDelete}
            />
          )}
          {profile === "business" && (
            <PoppupBusiness
              businessdata={modaldetailsbusiness}
              setmodaldetailsBusiness={setmodaldetailsBusiness}
              handleChange={handleChange}
              state={businessState}
              personalRef={personalRef}
              setPersonalRef={setPersonalRef}
              commercialRef={commercialRef}
              setCommercialRef={setCommercialRef}
              businessdatas={inputValues.business}
              handleChanges={handleChanges}
              handleDelete={handleDelete}
            />
          )}
        </div>

        <div>
          <hr />
        </div>
        <div className="Popup_buttons">
          <button className="Popup_buttons_cancel" onClick={handleClose}>
            {t('popupack.cancel')}
          </button>
          <button className="Popup_buttons_submit" onClick={onclcikSubmit}>
            {isLoading ? <Loader /> : <>{t('common.submitButton')}</>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Poppup;
